import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import About from './components/About';
import React, { useState } from 'react';
import Alert from './components/Alert';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  const [mode, setmode] = useState("light");
  const [alert, setalert] = useState(null);
  const showalert = (message, type) => {
    setalert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setalert(null);
    }, 1500)
  }
  const toogleMode = () => {
    if (mode === 'light') {
      setmode('dark');
      document.body.style.backgroundImage = 'radial-gradient(circle, #b91bc0, #9f3fd2, #7f54df, #5964e7, #1270eb)'
      showalert("Dark mode is been unabled", "success")
    }
    else {
      setmode('light');
      document.body.style.backgroundImage = 'linear-gradient(315deg, #f3f4f7 0%, #caccd1 74%)';
      showalert("Light mode is been unabled", "success")
    }
  }
  return (
    <>
      <Router>
        <Navbar title="TextUtiles" mode={mode} toogleMode={toogleMode} />
        <Alert alert={alert} />
        <div className="container my-3">
          <Switch>
            {/* //the exact keyword is used to avoid partial mataching of the router ex : /user and /user/details this both can be consider as same */}
            <Route exact path="/about">
              <About />
            </Route>
            <Route exact path="/">
              <TextForm heading="Here Is Your Text Area" mode={mode} showAlert={showalert} />
            </Route>
          </Switch>
          {/* <About></About> */}
        </div>
      </Router>
    </>
  );
}

export default App;
